import { render, staticRenderFns } from "./search-list.vue?vue&type=template&id=fa586898&scoped=true&"
import script from "./search-list.vue?vue&type=script&lang=js&"
export * from "./search-list.vue?vue&type=script&lang=js&"
import style0 from "./search-list.vue?vue&type=style&index=0&id=fa586898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa586898",
  null
  
)

export default component.exports